import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { TestLanguage } from "../hooks/testLanguage";
import { t } from "i18next";

export function Regionauto({
  regions,
  selectedRegion,
  setSelectedRegion,
  onSelect,
}) {
  const handleChange = (event, value) => {
    setSelectedRegion(value);
    if (onSelect && value) {
      onSelect("Region", value);
    }
  };
  const [loading, setLoading] = useState(false);

  return (
    <Autocomplete
      options={regions}
      getOptionLabel={(option) => TestLanguage(option, "name") || ""}
      value={selectedRegion}
      onChange={handleChange}
      disabled={regions?.length === 0}
      fullWidth
      renderInput={(params) => (
        <TextField
          {...params}
          InputLabelProps={{
            sx: {
              fontFamily: "Oswald, cairo",
              fontSize: "14px",
              color: "#000",
              fontWeight: "300"
            },
          }}
          label={t("drawerUnit.region")}
          variant="outlined"
          sx={{
            "& fieldset": {
              border: "none",
              boxShadow:
                "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
            },
            "& .MuiInputLabel-root": {
      color: "black",
    },
          }}
          InputProps={{
            ...params.InputProps,
            style: {
              borderRadius: "35px",
              backgroundColor: "#f5f5f5",
              fontWeight: "bold",
              fontSize: "14px",
              height: "40px",
            },
            endAdornment: loading ? <CircularProgress size={16} /> : "",
          }}
        />
      )}
    />
  );
}
